import axios from "axios";

// var url = "https://randomuser.me/";
// var url = "http://10.2.103.66";

/* var url = configData.service; */

const _url = "https://onrhml.forluz.org.br:4000";
// const _url = "https://onr.forluz.org.br:4000";
// let urlEndPoint = (process && process.env) ? process.env.NODE_ENV === 'development' ? url_prd : process.env : process.env;

// console.log(urlEndPoint);

const { REACT_APP_API_URL } = process.env; 
var url = REACT_APP_API_URL ? REACT_APP_API_URL : _url;
export const api = axios.create({
  baseURL: url,
});

api.interceptors.request.use(function (config) {
  
  config.headers.Authorization =  "Basic b25yZm9ybHV6OiFAIyQlXiYqKCk=";
  config.headers["tknFlz"] = "sowzcnv2ftks57w35mhufxsop37df3bo35x7ggdgobps33sewbtq";

  return config;
});

export default api;